export default "__VITE_ASSET__86435125__"